import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/system";
import { FontFamily } from "../theme/fontFamily";
import { fontWeight } from "../theme/fontWeight";
import { fontSize } from "../theme/fontSize";
import { IconButton, InputAdornment, InputLabel } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { ThemeColor } from "../theme/color";

const StyledTextField = styled(TextField)(
  ({ theme, customColor, padding }) => ({
    "& label.MuiInputLabel-root": {
      color: ThemeColor.BLACK, // Default label color
      fontFamily: FontFamily.Lato,
      fontWeight: fontWeight.W500,
      fontSize: fontSize.h4.medium,
    },
    "& label.MuiInputLabel-root.Mui-disabled": {
      color: `${ThemeColor.BLACK} !important`,
    },
    "& label.Mui-focused": {
      color: ThemeColor.LIGHTPURPLE,
      fontSize: fontSize.h4.large,
      // Label color when focused
    },
    // "& label.Mui-focused": {
    //   display: "none",
    // },
    // "& .MuiInput-underline:after": {
    //   bordeRadius: "30px",
    //   display: "none",
    // },
    "& .MuiOutlinedInput-root": {
      borderColor: "none",
      // borderRadius: "30px",
      // backgroundColor: "#F3F3F3",
      padding: padding,
      borderWidth: "2px",
      borderColor: ThemeColor.GREY,
      "& fieldset": {
        borderColor: "rgba(217, 217, 217, 3)",
      },
      "& input": {
        height: "12px",
      },
      "&:hover fieldset": {
        borderColor: "#F3F3F3",
      },
      // "&.Mui-focused fieldset": {
      //   display: "none",
      // },
      "&.Mui-focused fieldset": {
        borderColor: ThemeColor.LIGHTPURPLE, // Change this to your desired border color when focused
      },
      "& input::placeholder": {
        color: "#ced4da",
        opacity: 2,
        fontFamily: FontFamily.Lato,
        fontWeight: fontWeight.W400,
        fontSize: fontSize.h4.medium,
      },
      "&.Mui-disabled": {
        cursor: "not-allowed !important",
        "& input": {
          cursor: "not-allowed !important",
          color: "black !important",
          WebkitTextFillColor: "black !important",
        },
        "& fieldset": {
          border: "1px solid rgba(217, 217, 217, 1) !important",
        },
      },
    },
  })
);

const OutlinedInputField = ({
  label,
  value,
  onChange,
  name,
  type,
  placeholder = "",
  fullWidth = true,
  helperText,
  padding,
  disable,
  disabled,
  onBlur,
  defaultValue,
}) => {
  const [showPassword, setShowPassword] = useState(type === "password");

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <StyledTextField
        padding={padding}
        label={label}
        defaultValue={defaultValue}
        labelId="custom-select-label"
        id="custom-select"
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        type={type === "password" ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        fullWidth={fullWidth}
        variant="outlined"
        className="mb-3"
        helperText={helperText}
        // Callers pass a <Typography> as helperText, which renders a <p>. MUI's
        // FormHelperText is also a <p> by default, and <p> inside <p> is invalid
        // HTML. Render the wrapper as a <div> so nesting is legal.
        FormHelperTextProps={{ component: "div" }}
        disabled={disable || disabled}
        sx={{
          // "& .MuiOutlinedInput-input": {
          //   fontWeight: 400,
          //   fontSize: "1rem",
          //   lineHeight: "1.4375em",
          //   letterSpacing: "0.00938em",
          // },
          "& .MuiInputLabel-root": {
            fontWeight: "520 !important",
            fontSize: "0.9rem !important",
            // lineHeight: "1.4375em",
            letterSpacing: "0.00938em",
            fontFamily: "Lato !important",
          },
        }}
        InputProps={
          type === "password"
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {}
        }
      />
    </>
  );
};

export default OutlinedInputField;
